export interface UserContextRoleProfileIdDTO {
    profileCd?: string;
    profileId?: number;
}
